import { FC } from 'react';
import { formatDistance } from 'date-fns';
import { css, useTheme } from '@emotion/react';
import { Circle } from '@phosphor-icons/react';
import type { SSHKeyDocument } from 'common/account/ProfileDocuments';
import { Tooltip } from 'client/components/Tooltip';
import { Typography } from 'client/components/Typography';

const sshKeyInfoStyle = css`
  .body2:first-of-type {
    display: flex;
    align-items: center;
    margin-bottom: 0.1rem;

    svg {
      margin-right: 0.25rem;
    }
  }
`;

const timeFormat = new Intl.DateTimeFormat();

export type SSHKeyInfoProps = Pick<SSHKeyDocument, 'fingerprint' | 'timeCreate'>;

// TODO: Show the "last used" time here if we ever get something like it...
export const SSHKeyInfo: FC<SSHKeyInfoProps> = ({ fingerprint, timeCreate }) => {
  const theme = useTheme();
  const date = new Date(timeCreate as string);

  return (
    <div css={sshKeyInfoStyle}>
      <Typography variant="body2">
        <Circle size={12} weight="fill" color={theme.color.primary[100]} /> Active
      </Typography>
      <Typography variant="fineprint">{fingerprint ? `SHA256:${fingerprint}` : 'Unknown fingerprint'}</Typography>
      <Tooltip title={timeFormat.format(date)} side="left">
        <Typography variant="fineprint">Added {formatDistance(date, new Date(), { addSuffix: true })}</Typography>
      </Tooltip>
    </div>
  );
};
